import { hidePhoneNumber } from "helper/phone";
import { formatPriceNoDecimal } from "helper/common";
import React, { useState } from "react";
import { Button, Select } from "antd";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";

export function Text({ text, className }) {
  return <span className={className}>{text}</span>;
}

export function CustomerText({ firstName, phoneNumber, email }) {
  const [showPhone, setShowPhone] = useState(false);

  const togglePhoneVisibility = () => {
    setShowPhone(!showPhone);
  };

  return (
    <div className="customer-info">
      <span className="customer-name">{firstName}</span>
      <span className="customer-email">{email}</span>

      <span className="customer-phone">
        <span>{showPhone ? phoneNumber : hidePhoneNumber(phoneNumber)}</span>
        <Button
          type="text"
          size="small"
          onClick={togglePhoneVisibility}
          icon={showPhone ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        />
      </span>
    </div>
  );
}

export function PriceText({ price, className }) {
  return <span className={className}>{formatPriceNoDecimal(price)} ₫</span>;
}

export function DateText({ date, className }) {
  return (
    <span className={className}>
      {date ? new Date(date).toLocaleString("vi-VN") : ""}
    </span>
  );
}

export const SelectText = ({
  defaultValue,
  options,
  onUpdate,
  textClass,
  textValue,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(defaultValue);

  const handleStatusChange = async (value) => {
    try {
      setLoading(true);
      setValue(value);
      onUpdate(value);
    } catch (error) {
    } finally {
      setLoading(false);
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <Select
        defaultValue={value}
        style={{ width: "100%" }}
        onChange={handleStatusChange}
        loading={loading}
        autoFocus
        onBlur={() => setIsEditing(false)}
        options={options}
        size="small"
      />
    );
  }

  return (
    <div onClick={() => setIsEditing(true)} style={{ cursor: "pointer" }}>
      <Text className={textClass} text={textValue} />
    </div>
  );
};
